module.exports = __webpack_public_path__ + "img/cube-02.1a9f3df2.svg";